import React, { FC, useState, ReactNode } from 'react';
import { Modal } from '../../../../../../components';
import styles from './DownloadHealthCheckupInstitution.scss';
import { useNotify } from '../../../../../../hooks/useNotify';
import { saveAs } from 'file-saver';
import NProgress from 'nprogress';
import Button from 'jbc-front/components/Button';
import classNames from 'classnames';
import { exportHealthCheckupInstitution } from '../../../../../../api';
import { isErrorWithMessage } from '../../../../../../components';

type Option = { value: string; label: string; disabled?: boolean };

interface RadioFieldProps {
  label: string;
  options: Option[];
  state: string;
  setState: (value: string) => void;
  note?: ReactNode;
  radioNote?: ReactNode;
  disabled?: boolean;
}

interface InputRadioProps {
  label: string;
  value: string;
  disabled?: boolean;
  state: string;
  setState: (value: string) => void;
}

const RadioField: FC<RadioFieldProps> = ({ label, options, state, setState, note, radioNote }) => (
  <div className={styles.field}>
    <div className={styles.label}>{label}</div>
    <div className={styles.note}>{note}</div>
    <div>
      {options.map(({ label, value, disabled }) => {
        return <InputRadio {...{ label, value, disabled, state, setState }} key={value} />;
      })}
    </div>
    {radioNote && <div className={styles.note}>{radioNote}</div>}
  </div>
);

const InputRadio: FC<InputRadioProps> = ({ label, value, disabled, state, setState }) => (
  <div style={{ display: 'inline-block' }} className={'input-label'} key={value}>
    <label>
      <input
        type="radio"
        value={value}
        checked={value === state}
        disabled={disabled}
        className={classNames('m-radio-input', { disabled })}
        onClick={() => setState(value)}
      />
      <span className={classNames('m-radio-parts', { disabled })}>{label}</span>
    </label>
  </div>
);

const downloadOptions = [
  { value: 'UTF-8', label: 'UTF-8（推奨）' },
  { value: 'Windows-31J', label: 'Shift-JIS' }
];

export const DownloadHealthCheckupInstitution = () => {
  const [encoding, setEncoding] = useState('UTF-8');
  const [loading, setLoading] = useState(false);
  const notify = useNotify();
  const exportResult = async hideModal => {
    NProgress.start();
    setLoading(true);
    try {
      await exportHealthCheckupInstitution({
        encoding: encoding
      }).then(res => {
        saveAs(res.data, decodeURIComponent(res.headers['content-disposition'].match(/filename="(.*)"/)[1]));
      });
      hideModal();
    } catch (err) {
      let errorMessage;
      if (isErrorWithMessage(err, '422')) {
        errorMessage = '使用できない文字が含まれています。';
      } else if (isErrorWithMessage(err, '400')) {
        errorMessage = 'encodingは[UTF-8][Windows-31J]いずれかを設定してください';
      } else {
        errorMessage = '予期せぬエラーが発生しました';
      }
      notify(errorMessage, 'error');
    } finally {
      NProgress.done();
      setLoading(false);
    }
  };
  return (
    <Modal>
      {({ hideModal, showModal, isOpen }) => {
        return (
          <>
            <Button widthAuto onClick={() => showModal()}>
              実施機関ダウンロード
            </Button>
            {isOpen && (
              <form>
                <Modal.Modal>
                  <div className={styles.modal}>
                    <Modal.Header hideModal={hideModal}>実施機関ダウンロード</Modal.Header>
                    <Modal.Body>
                      <RadioField
                        label="ファイル形式選択"
                        options={downloadOptions}
                        state={encoding}
                        setState={setEncoding}
                        radioNote="Excel2016より前のバージョンのExcelをお使いの方はShift-JISをご利用ください。"
                      />
                    </Modal.Body>
                    <Modal.Footer>
                      <div className={styles.modalFooter}>
                        <Modal.Buttons>
                          <Button className={styles.cancelButton} onClick={hideModal}>
                            キャンセル
                          </Button>
                          <Button
                            className={styles.sendButton}
                            primary
                            onClick={() => exportResult(hideModal)}
                            disabled={loading}>
                            ダウンロード
                          </Button>
                        </Modal.Buttons>
                      </div>
                    </Modal.Footer>
                  </div>
                </Modal.Modal>
              </form>
            )}
          </>
        );
      }}
    </Modal>
  );
};
